export const productionOrigin = 'https://getcartwheel.com';

export const publicOrganization = {
  name: 'Cartwheel',
  description:
    'Cartwheel is an AI research lab and product company. We build foundation models for human and object motion, and the tools that put them to work across media and the physical world.',
  url: productionOrigin,
  logo: `${productionOrigin}/web-app-manifest-512x512.png`,
  address: {
    '@type': 'PostalAddress',
    streetAddress: '46 Howard Street, Suite 607',
    addressLocality: 'New York',
    addressRegion: 'NY',
    postalCode: '10013',
    addressCountry: 'US',
  },
  sameAs: [
    'https://linkedin.com/company/getcartwheel',
    'https://instagram.com/getcartwheel',
    'https://tiktok.com/@getcartwheel',
  ],
} as const;
